import { isFastFactItemDefined } from './isFastFactDefined';
import { IFastFactItem, IFastFactBlock } from './types';

export function isAnyFastFactItemDefined(blockData: IFastFactBlock) {
  return blockData?.items?.some((d: IFastFactItem) => isFastFactItemDefined(d));
}
